import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:items-center justify-between bg-white border-b border-gray-200 flex py-4 px-8 gap-4" }
const _hoisted_2 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "px-8 py-6" }
const _hoisted_9 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_10 = { class: "py-6" }
const _hoisted_11 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_12 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { translate } from "@/utils/tools";

import Toast from "@/components/tools/Toast.vue";
import {
  CouponConditionModeEnum,
  CouponConditionType,
} from "@/views/coupon/type/coupon-condition.type";
import CreateCouponConditionDialog from "@/components/dialogs/coupon/CreateCouponConditionDialog.vue";
import UpdateCouponConditionDialog from "@/components/dialogs/coupon/UpdateCouponConditionDialog.vue";
import GenerateCouponDialog from "@/components/dialogs/coupon/GenerateCouponDialog.vue";
import GenerateGenericCouponDialog from "@/components/dialogs/coupon/GenerateGenericCouponDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CouponCondition',
  setup(__props) {

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const addModalOpen = ref(false);
const editModalOpen = ref(false);
const generateModalOpen = ref(false);
const generateGenericModalOpen = ref(false);
const dataRows = ref<CouponConditionType[]>([]);
const isLoaded = ref(false);
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning:false
});


const createCouponConditionData= ref({name: '', bonusAmount: 0, bonusLimit: 0, depositMinimum: 0,descriptions: '', turnoverAmount: 0, limitUsePerUser: 0, limitUsePerUserPerDay: 0})

const updateCouponConditionData= ref<CouponConditionType>()

const generateCouponConditionData= ref()
const generateGenericCouponConditionData= ref()

const columns = ref([
  {
    label: translate("messages.coupon.name"),
    field: "name",
    align: "center",
    format: (data: CouponConditionType) => data.name ? data.name : '-',
  },
  {
    label: translate("messages.coupon.couponMode"),
    field: "couponMode",
    align: "center",
    format: (data: CouponConditionType) => data.codeMode ? translate(`messages.coupon.${data.codeMode}`) : '-',
  },
  {
    label: translate("messages.coupon.bonusAmount"),
    field: "paymentName",
    align: "center",
    format: (data: CouponConditionType) => (data.amount ? data.amount : "-"),
  },
  {
    label: translate("messages.coupon.bonusCap"),
    field: "maxAmount",
    align: "center",
    format: (data: CouponConditionType) => data.maxAmount ? data.maxAmount : "-",
  },
  {
    label: translate("messages.coupon.type"),
    field: "type",
    align: "center",
    format: (data: CouponConditionType) => data.type ? translate(`messages.coupon.${data.type}`): "-",
  },
  {
    label: translate("messages.coupon.source"),
    field: "source",
    align: "center",
    format: (data: CouponConditionType) => {
      return data.depositType ? translate(`messages.coupon.${data.depositType}`) : "-"
    },
  },
  {
    label: translate("messages.coupon.turnover"),
    field: "turnover",
    align: "center",
    format: (data: CouponConditionType) => (data.turnover ? translate(`messages.coupon.${data.turnover}`) : "-"),
  },

  {
    label: translate("messages.coupon.createdAt"),
    field: "createdAt",
    align: "center",
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.coupon.update"),
    field: "status",
    align: "center",
    isFunction: true,
    function: async (data: any) => {
      updateCouponConditionData.value = data;
      manageOpenEditModal(true)
      return
    },
    class: (data: any) => {
      return 'content-center bg-yellow-500 hover:bg-yellow-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.coupon.update")
    },
  },
  {
    label: translate("messages.coupon.generate"),
    field: "status",
    align: "center",
    isFunction: true,
    function: async (data: any) => {
      if(data.codeMode === CouponConditionModeEnum.UNIQUE){
        generateCouponConditionData.value = {couponConditionId: data.id}
        manageOpenGenerateModal(true)
      }
      if(data.codeMode === CouponConditionModeEnum.GENERIC){
        generateGenericCouponConditionData.value = {couponConditionId: data.id}
        manageOpenGenerateGenericModal(true)

      }
      return
    },
    class: (data: any) => {
      return 'content-center bg-green-500 hover:bg-green-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.coupon.generate")
    },
  },
  {
    label: translate("messages.coupon.viewCoupon"),
    field: "View Coupon",
    align: "center",
    isFunction: true,
    function: async (data: any) => {
      window.open(`/coupon?couponConditionId=${data.id}&generic=${(data.codeMode == CouponConditionModeEnum.GENERIC)}`, '_blank');
      return
    },
    class: (data: any) => {
      return 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.coupon.viewCoupon")
    },
  },
]);

const pageConfig = ref({
  search: ``,
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  sort: [["id", "ASC"]],
});



const fetchPageData = async () => {
  isLoaded.value = false

  const { page, rowsPerPage, search } = pageConfig.value;

  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page,
    pageSize: rowsPerPage,
    name: search ? search : undefined,
    sortBy: pageConfig.value.sort,
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon-condition/pagination`;
  const data = await axios
    .post<CouponConditionType[]>(url, payload)
    .then(({ data }) => data);

  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const createCouponCondition = async (payload: any) => {
  try {
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon-condition/create`;
    const data = await axios
        .post<CouponConditionType>(url, payload)
    if(data.status === 200 || data.status === 201){
      createCouponConditionData.value = {name: '', bonusAmount: 0, bonusLimit: 0, depositMinimum: 0,descriptions: '', turnoverAmount: 0, limitUsePerUser: 0, limitUsePerUserPerDay: 0}
      addModalOpen.value = false
    }
    fetchPageData()
  }catch (e) {
    toastConfig.value = {
      show: true,
      message: e?.response?.data?.message || `error`,
      success: false,
      warning: false
    }
  }

};

const generateCoupon = async (payload: any) => {
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon-condition/generate`;
  const data = await axios
      .post(url, payload)
      .then(({ data }) => data);
  generateModalOpen.value = false
  fetchPageData()
};

const generateGenericCoupon = async (payload: any) => {
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon-condition/generate-generic`;
  const data = await axios
      .post(url, payload)
      .then(({ data }) => data);
  generateGenericModalOpen.value = false
  fetchPageData()
};

const updateCouponCondition = async (payload: any) => {
  try {
    const {id, ...dataUpdate} = payload;
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon-condition/update/${id}`;
    const data = await axios
        .put<CouponConditionType>(url, {...dataUpdate, descriptions: updateCouponConditionData.value?.descriptions, name: updateCouponConditionData.value?.name, amount: Number(updateCouponConditionData.value?.amount), maxAmount: Number(updateCouponConditionData.value?.maxAmount)})
        .then(({ data }) => data);
    editModalOpen.value = false
    fetchPageData()
  }catch (e) {
    toastConfig.value = {
      show: true,
      message: e?.response?.data?.message || `error`,
      success: false,
      warning: false
    }
  }

};


const manageOpenAddModal = (open: boolean) => {
  addModalOpen.value = open
}

const manageOpenEditModal = (open: boolean) => {
  editModalOpen.value = open
}

const manageOpenGenerateModal = (open: boolean) => {
  generateModalOpen.value = open
}

const manageOpenGenerateGenericModal = (open: boolean) => {
  generateGenericModalOpen.value = open
}


onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.coupon.couponCondition')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(SearchIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
            class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
            placeholder: _ctx.$t('messages.coupon.search'),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData(true))),
            type: "search",
            name: "search"
          }, null, 40, _hoisted_6), [
            [_vModelText, pageConfig.value.search]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addModalOpen.value = true)),
          class: "md:ml-3 inline-flex whitespace-nowrap items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-white mr-2",
            icon: ['fa', 'plus'],
            transform: ""
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.coupon.add")), 1)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value
          }, null, 8, ["columns", "data"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ], 512), [
      [_vShow, isLoaded.value]
    ]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"]),
    _createVNode(CreateCouponConditionDialog, {
      "coupon-condition-create": createCouponConditionData.value,
      show: addModalOpen.value,
      "onUpdate:show": manageOpenAddModal,
      onOnCreateTicket: createCouponCondition
    }, null, 8, ["coupon-condition-create", "show"]),
    _createVNode(UpdateCouponConditionDialog, {
      "coupon-condition-update": updateCouponConditionData.value,
      show: editModalOpen.value,
      "onUpdate:show": manageOpenEditModal,
      onOnUpdateTicket: updateCouponCondition,
      "onUpdate:amountValue": _cache[5] || (_cache[5] = (amount) => updateCouponConditionData.value.amount = amount),
      "onUpdate:maxAmountValue": _cache[6] || (_cache[6] = (maxAmount) => updateCouponConditionData.value.maxAmount = maxAmount),
      "onUpdate:nameValue": _cache[7] || (_cache[7] = (name) => updateCouponConditionData.value.name = name),
      "onUpdate:descriptionsValue": _cache[8] || (_cache[8] = (descriptions) => updateCouponConditionData.value.descriptions = descriptions),
      "onUpdate:turnoverAmountValue": _cache[9] || (_cache[9] = (turnoverAmount) => updateCouponConditionData.value.turnoverAmount = turnoverAmount),
      "onUpdate:depositMinimum": _cache[10] || (_cache[10] = (depositMinimum) => updateCouponConditionData.value.depositMinimum = depositMinimum),
      "onUpdate:limitUsePerUser": _cache[11] || (_cache[11] = (limitUsePerUser)=> updateCouponConditionData.value.limitUsePerUser = limitUsePerUser),
      "onUpdate:limitUsePerUserPerDay": _cache[12] || (_cache[12] = (limitUsePerUserPerDay)=> updateCouponConditionData.value.limitUsePerUserPerDay = limitUsePerUserPerDay),
      "onUpdate:limitUsePerCampaign": _cache[13] || (_cache[13] = (limitUsePerCampaign)=> updateCouponConditionData.value.limitUsePerCampaign = limitUsePerCampaign)
    }, null, 8, ["coupon-condition-update", "show"]),
    _createVNode(GenerateCouponDialog, {
      "coupon-generate-data": generateCouponConditionData.value,
      show: generateModalOpen.value,
      "onUpdate:show": manageOpenGenerateModal,
      onOnGenerateCoupon: generateCoupon
    }, null, 8, ["coupon-generate-data", "show"]),
    _createVNode(GenerateGenericCouponDialog, {
      "coupon-generate-data": generateGenericCouponConditionData.value,
      show: generateGenericModalOpen.value,
      "onUpdate:show": manageOpenGenerateGenericModal,
      onOnGenerateCoupon: generateGenericCoupon
    }, null, 8, ["coupon-generate-data", "show"])
  ], 64))
}
}

})